












import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import DocButton from '@/components/ui/buttons/DocButton.vue';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import ClickOutsideElement from '@/heplers/clickOutsideDirective';
import { Mutation, State } from 'vuex-class';
import { LocaleItem, StoreMutations } from '@/templates/DataNames';
import { localeList } from '@/heplers';

@Component({
  components: {
    DocButton,
    DocIcon,
  },
  directives: {
    ClickOutsideElement,
  },
})
export default class LocaleSelector extends Vue {
  @State locale: LocaleItem;
  @State('pageRendered') pageRendered: boolean;
  @Mutation(StoreMutations.SET_CURRENT_LOCALE) setCurrentLocale: (locale: any) => void;

  public localesAvailable: LocaleItem[] = localeList;
  public currentLocale: LocaleItem = localeList[0];
  public localeSelectorOpened = false;
  public counter = 0;

  toogleLocaleSelector(): void {
    this.localeSelectorOpened = !this.localeSelectorOpened;
  }

  closeLocaleSelector(): void {
    this.toogleLocaleSelector();
  }

  setLocale(locale: LocaleItem): void {
    if (this.currentLocale != locale) {
      this.currentLocale = locale;
      this.setCurrentLocale(locale.lc);
      this.localeSelectorOpened = !this.localeSelectorOpened;
      this.$router.push({ query: { locale: locale.lc } });
    } else this.localeSelectorOpened = !this.localeSelectorOpened;
  }

  mounted() {
    this.currentLocale = this.locale;
  }
}
